import React, { useState } from 'react';
import Select from 'react-select';
import Offcanvas from 'react-bootstrap/Offcanvas';
import ChargesTab from './Charges/ChargesTab';
import ProfitLossTab from './Charges/ProfitLossTab';
import ExchangeRateTab from './Charges/ExchangeRateTab';




const ChargesTabs = () => {

    return (
        <>
            <div className="row border-bottom-2 pb-3">

<div className="py-2">
    <div className="row d-flex align-items-center gap-1 flex-row ">

        {/* <i className="fa fa-map-marker-alt text-danger me-1"></i> */}
        <span className="text-danger fw-bold">Flow To Be Added</span>
        <span className="text-muted">: Flow Will be Added in Future.</span>

    </div>
</div>

</div>
        </>
    )
}

export default ChargesTabs;